// This file is auto-generated by @hey-api/openapi-ts

import * as z from "zod"

/**
 * Represents patent application meta data properties
 */
export const zApplicationMetaData = z
  .object({
    nationalStageIndicator: z
      .boolean()
      .register(z.globalRegistry, {
        description:
          "Indicates whether this application is a national application which entered the national stage from an international PCT application",
      })
      .optional(),
    entityStatusData: z
      .object({
        smallEntityStatusIndicator: z
          .boolean()
          .register(z.globalRegistry, {
            description: "Indicates whether the applicant qualifies for small entity status",
          })
          .optional(),
        businessEntityStatusCategory: z
          .string()
          .register(z.globalRegistry, {
            description:
              "Status of business entity being established for the purpose of paying a fee such as a filing fee and a maintenance fee",
          })
          .optional(),
      })
      .register(z.globalRegistry, {
        description: "Indicates the applicant's entity status",
      })
      .optional(),
    publicationDateBag: z.array(z.string()).optional(),
    publicationSequenceNumberBag: z.array(z.string()).optional(),
    publicationCategoryBag: z.array(z.string()).optional(),
    docketNumber: z.string().optional(),
    firstInventorToFileIndicator: z.string().optional(),
    firstApplicantName: z.string().optional(),
    firstInventorName: z.string().optional(),
    applicationConfirmationNumber: z.number().optional(),
    applicationStatusDate: z.string().optional(),
    applicationStatusDescriptionText: z.string().optional(),
    filingDate: z
      .string()
      .register(z.globalRegistry, {
        description:
          "The date assigned by the Patent Office that identifies when an application meets certain criteria to qualify as having been filed. Refers to ST.9 INID Code 22.",
      })
      .optional(),
    effectiveFilingDate: z
      .string()
      .register(z.globalRegistry, {
        description:
          "The date according to PTO criteria that the patent case qualified as having been 'filed'.  The effective filing date is the same or later than the Filing Date.  The filing date can be changed due to a subsequent action on an application patent case.",
      })
      .optional(),
    grantDate: z.string().optional(),
    groupArtUnitNumber: z
      .string()
      .register(z.globalRegistry, {
        description: "GAU Code",
      })
      .optional(),
    applicationTypeCode: z
      .string()
      .register(z.globalRegistry, {
        description: "Code corresponding to Utility, Plant, Design, or Reissue",
      })
      .optional(),
    applicationTypeLabelName: z.string().optional(),
    applicationTypeCategory: z.string().optional(),
    inventionTitle: z.string().optional(),
    patentNumber: z.string().optional(),
    applicationStatusCode: z.int().optional(),
    earliestPublicationNumber: z
      .string()
      .register(z.globalRegistry, {
        description: "Publication number corresponding to the earliest publication",
      })
      .optional(),
    earliestPublicationDate: z.string().optional(),
    pctPublicationNumber: z
      .string()
      .register(z.globalRegistry, {
        description:
          "The unique identifier assigned to the publication of an international patent application in the PCT Gazette by the International Bureau (IB) of the World Intellectual Property Organization (WIPO).",
      })
      .optional(),
    pctPublicationDate: z.string().optional(),
    internationalRegistrationPublicationDate: z
      .string()
      .register(z.globalRegistry, {
        description: "The date that the IPR is published by the International Bureau",
      })
      .optional(),
    internationalRegistrationNumber: z
      .string()
      .register(z.globalRegistry, {
        description:
          "The number assigned by the International Bureau to an international registration upon registering an industrial design, a trademark or other type of IPR in the International Register",
      })
      .optional(),
    examinerNameText: z
      .string()
      .register(z.globalRegistry, {
        description: "Name of patent examiner",
      })
      .optional(),
    class: z
      .string()
      .register(z.globalRegistry, {
        description: "The first hierarchical level in the USPC classification schedule",
      })
      .optional(),
    subclass: z
      .string()
      .register(z.globalRegistry, {
        description: "The second highest hierarchical level  in the USP C classification schedule",
      })
      .optional(),
    uspcSymbolText: z
      .string()
      .register(z.globalRegistry, {
        description:
          "The first hierarchical level in the USPC classification schedule/ The second highest hierarchical level in the USP C classification schedule",
      })
      .optional(),
    customerNumber: z
      .int()
      .register(z.globalRegistry, {
        description: "Correspondence address of the application inherited from the customer.",
      })
      .optional(),
    cpcClassificationBag: z
      .array(z.string())
      .register(z.globalRegistry, {
        description: "Collection of Classifications for CPC",
      })
      .optional(),
    applicantBag: z
      .array(
        z.object({
          applicantNameText: z.string().optional(),
          firstName: z.string().optional(),
          middleName: z.string().optional(),
          lastName: z.string().optional(),
          preferredName: z.string().optional(),
          namePrefix: z.string().optional(),
          nameSuffix: z.string().optional(),
          countryCode: z.string().optional(),
          correspondenceAddressBag: z
            .array(
              z.object({
                nameLineOneText: z.string().optional(),
                nameLineTwoText: z.string().optional(),
                geographicRegionName: z.string().optional(),
                geographicRegionCode: z.string().optional(),
                cityName: z.string().optional(),
                countryCode: z.string().optional(),
                countryName: z.string().optional(),
                postalAddressCategory: z.string().optional(),
              }),
            )
            .optional(),
        }),
      )
      .optional(),
    inventorBag: z
      .array(
        z.object({
          firstName: z.string().optional(),
          middleName: z.string().optional(),
          lastName: z.string().optional(),
          namePrefix: z.string().optional(),
          nameSuffix: z.string().optional(),
          preferredName: z.string().optional(),
          countryCode: z.string().optional(),
          inventorNameText: z.string().optional(),
          correspondenceAddressBag: z
            .array(
              z.object({
                nameLineOneText: z.string().optional(),
                nameLineTwoText: z.string().optional(),
                geographicRegionName: z.string().optional(),
                geographicRegionCode: z.string().optional(),
                cityName: z.string().optional(),
                countryCode: z.string().optional(),
                countryName: z.string().optional(),
                postalAddressCategory: z.string().optional(),
              }),
            )
            .optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "Represents patent application meta data properties",
  })

/**
 * Patent term adjustment data
 */
export const zPatentTermAdjustment = z
  .object({
    aDelayQuantity: z
      .int()
      .register(z.globalRegistry, {
        description:
          "A delays quantity number of adjustments to the term of the patent based upon USPTO delays included in the PTA determination that is mailed as part of the ISSUE NOTIFICATION LETTER.",
      })
      .optional(),
    adjustmentTotalQuantity: z
      .int()
      .register(z.globalRegistry, {
        description:
          "Patent term adjustment total quantity number that is a summation of NONOVERLAPPING USPTO DELAYS (+/- PTO MANUAL ADJUSTMENTS) - APPLICANT DELAYS.",
      })
      .optional(),
    applicantDayDelayQuantity: z
      .int()
      .register(z.globalRegistry, {
        description:
          "Patent term adjustment applicant delays quantity number of the patent term due to the Applicant's failure to engage in reasonable efforts to conclude prosecution of the application for the cumulative period in excess of three",
      })
      .optional(),
    bDelayQuantity: z
      .int()
      .register(z.globalRegistry, {
        description:
          "B delays quantity number of adjustments to the term of the patent based upon the patent failing to issue within three years of the actual filing date of the application at the time that the issue notification letter is generated and an issue date has been established.",
      })
      .optional(),
    cDelayQuantity: z
      .int()
      .register(z.globalRegistry, {
        description:
          "C delays quantity number of adjustments to the term of the patent based upon USPTO delays caused by interference proceedings, secrecy orders, and successful appellate reviews.",
      })
      .optional(),
    nonOverlappingDayQuantity: z
      .number()
      .register(z.globalRegistry, {
        description:
          "Patent term adjustment non overlapping days quantity number of overall summation of the USPTO delays minus any overlapping days.",
      })
      .optional(),
    overlappingDayQuantity: z
      .number()
      .register(z.globalRegistry, {
        description:
          "Patent term adjustment overlapping days quantity number that reflects the calculation of overlapping delays consistent with the federal circuit's interpretation.",
      })
      .optional(),
    patentTermAdjustmentHistoryDataBag: z
      .array(
        z.object({
          eventDate: z
            .string()
            .register(z.globalRegistry, {
              description: "The date that the symbol was assigned to the patent document",
            })
            .optional(),
          applicantDayDelayQuantity: z.int().optional(),
          eventDescriptionText: z.string().optional(),
          eventSequenceNumber: z.number().optional(),
          ipOfficeDayDelayQuantity: z
            .int()
            .register(z.globalRegistry, {
              description:
                "Number of days the UPSTO personnel adjusting the calculation to increase or decrease the patent term adjustment based upon a request for reconsideration of the patent term adjustment.",
            })
            .optional(),
          originatingEventSequenceNumber: z.number().optional(),
          ptaPTECode: z.string().optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "Patent term adjustment data",
  })

/**
 * The collection of national assignments related to a patent
 */
export const zAssignment = z
  .object({
    reelNumber: z
      .int()
      .register(z.globalRegistry, {
        description: "1-6 digit number identifies the reel number to be used to locate the assignment on microfilm.",
      })
      .optional(),
    frameNumber: z
      .int()
      .register(z.globalRegistry, {
        description:
          "1-4 digit number that identifies the frame number to be used to locate the first image(page) of the assignment on microfilm.",
      })
      .optional(),
    reelAndFrameNumber: z.string().optional(),
    pageTotalQuantity: z.int().optional(),
    imageAvailableStatusCode: z.boolean().optional(),
    assignmentDocumentLocationURI: z.string().optional(),
    assignmentReceivedDate: z.string().optional(),
    assignmentRecordedDate: z.string().optional(),
    assignmentMailedDate: z
      .string()
      .register(z.globalRegistry, {
        description: "The date an assignment request was mailed to the office or received by the office",
      })
      .optional(),
    conveyanceText: z
      .string()
      .register(z.globalRegistry, {
        description:
          "A description of the nature of the interest conveyed or transaction to be recorded in an assignment. Examples of the types of descriptions `include:` assignment, security agreement, merger, change of name, license, foreclosure, lien,",
      })
      .optional(),
    assignorBag: z
      .array(
        z.object({
          assignorName: z.string().optional(),
          executionDate: z.string().optional(),
        }),
      )
      .optional(),
    assigneeBag: z
      .array(
        z.object({
          assigneeNameText: z.string().optional(),
          assigneeAddress: z
            .object({
              addressLineOneText: z.string().optional(),
              addressLineTwoText: z.string().optional(),
              addressLineThreeText: z.string().optional(),
              addressLineFourText: z.string().optional(),
              cityName: z.string().optional(),
              geographicRegionName: z.string().optional(),
              geographicRegionCode: z.string().optional(),
              countryName: z.string().optional(),
              postalCode: z.string().optional(),
              countryOrStateCode: z.string().optional(),
              ictStateCode: z.string().optional(),
              ictCountryCode: z.string().optional(),
            })
            .optional(),
        }),
      )
      .optional(),
    correspondenceAddress: z.record(z.string(), z.unknown()).optional(),
    domesticRepresentative: z
      .object({
        name: z.string().optional(),
        addressLineOneText: z.string().optional(),
        addressLineTwoText: z.string().optional(),
        addressLineThreeText: z.string().optional(),
        addressLineFourText: z.string().optional(),
        cityName: z.string().optional(),
        postalCode: z.string().optional(),
        geographicRegionName: z.string().optional(),
        countryName: z.string().optional(),
        emailAddress: z.string().optional(),
        lastIngestionDateTime: z.string().optional(),
      })
      .register(z.globalRegistry, {
        description: "US representative for foreign entity",
      })
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "The collection of national assignments related to a patent",
  })

/**
 * An attorney selected by the applicant or owner of an intellectual property to represent them before the national office.
 */
export const zRecordAttorney = z
  .object({
    customerNumberCorrespondenceData: z
      .object({
        patronIdentifier: z.number().optional(),
        organizationStandardName: z.string().optional(),
        powerOfAttorneyAddressBag: z
          .array(
            z.object({
              nameLineOneText: z.string().optional(),
              addressLineOneText: z.string().optional(),
              addressLineTwoText: z.string().optional(),
              geographicRegionName: z.string().optional(),
              geographicRegionCode: z.string().optional(),
              postalCode: z.string().optional(),
              cityName: z.string().optional(),
              countryCode: z.string().optional(),
              countryName: z.string().optional(),
            }),
          )
          .optional(),
        telecommunicationAddressBag: z
          .array(
            z.object({
              telecommunicationNumber: z.string().optional(),
              extensionNumber: z.string().optional(),
              telecomTypeCode: z.string().optional(),
            }),
          )
          .optional(),
      })
      .register(z.globalRegistry, {
        description: "Correspondence address of the application inherited from the customer.",
      })
      .optional(),
    powerOfAttorneyBag: z
      .array(
        z.object({
          firstName: z.string().optional(),
          middleName: z.string().optional(),
          lastName: z.string().optional(),
          namePrefix: z.string().optional(),
          nameSuffix: z.string().optional(),
          preferredName: z.string().optional(),
          countryCode: z.string().optional(),
          registrationNumber: z.string().optional(),
          activeIndicator: z.string().optional(),
          registeredPractitionerCategory: z.string().optional(),
          attorneyAddressBag: z
            .array(
              z.object({
                nameLineOneText: z.string().optional(),
                nameLineTwoText: z.string().optional(),
                addressLineOneText: z.string().optional(),
                addressLineTwoText: z.string().optional(),
                geographicRegionName: z.string().optional(),
                geographicRegionCode: z.string().optional(),
                postalCode: z.string().optional(),
                cityName: z.string().optional(),
                countryCode: z.string().optional(),
                countryName: z.string().optional(),
              }),
            )
            .optional(),
          telecommunicationAddressBag: z
            .array(
              z.object({
                telecommunicationNumber: z.string().optional(),
                extensionNumber: z.string().optional(),
                telecomTypeCode: z.string().optional(),
              }),
            )
            .optional(),
        }),
      )
      .optional(),
    attorneyBag: z
      .array(
        z.object({
          firstName: z.string().optional(),
          middleName: z.string().optional(),
          lastName: z.string().optional(),
          namePrefix: z.string().optional(),
          nameSuffix: z.string().optional(),
          registrationNumber: z.string().optional(),
          activeIndicator: z.string().optional(),
          registeredPractitionerCategory: z.string().optional(),
          attorneyAddressBag: z
            .array(
              z.object({
                nameLineOneText: z.string().optional(),
                nameLineTwoText: z.string().optional(),
                addressLineOneText: z.string().optional(),
                addressLineTwoText: z.string().optional(),
                geographicRegionName: z.string().optional(),
                geographicRegionCode: z.string().optional(),
                postalCode: z.string().optional(),
                cityName: z.string().optional(),
                countryCode: z.string().optional(),
                countryName: z.string().optional(),
              }),
            )
            .optional(),
          telecommunicationAddressBag: z
            .array(
              z.object({
                telecommunicationNumber: z.string().optional(),
                extensionNumber: z.string().optional(),
                telecomTypeCode: z.string().optional(),
              }),
            )
            .optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description:
      "An attorney selected by the applicant or owner of an intellectual property to represent them before the national office.",
  })

export const zParentContinuityData = z.object({
  firstInventorToFileIndicator: z
    .boolean()
    .register(z.globalRegistry, {
      description: "Indicates first inventor to file.",
    })
    .optional(),
  parentApplicationStatusCode: z.int().optional(),
  parentPatentNumber: z.string().optional(),
  parentApplicationStatusDescriptionText: z.string().optional(),
  parentApplicationFilingDate: z.string().optional(),
  parentApplicationNumberText: z.string().optional(),
  childApplicationNumberText: z.string().optional(),
  claimParentageTypeCode: z.string().optional(),
  claimParentageTypeCodeDescriptionText: z.string().optional(),
})

export const zChildContinuityData = z.object({
  childApplicationStatusCode: z.number().optional(),
  parentApplicationNumberText: z.string().optional(),
  childApplicationNumberText: z
    .string()
    .register(z.globalRegistry, {
      description:
        "Application number of the child application, which is the unique value assigned by the USPTO to a patent application upon receipt",
    })
    .optional(),
  childApplicationStatusDescriptionText: z.string().optional(),
  childApplicationFilingDate: z.string().optional(),
  firstInventorToFileIndicator: z.boolean().optional(),
  childPatentNumber: z.string().optional(),
  claimParentageTypeCode: z.string().optional(),
  claimParentageTypeCodeDescriptionText: z.string().optional(),
})

export const zForeignPriority = z.object({
  ipOfficeName: z.string().optional(),
  filingDate: z.string().optional(),
  applicationNumberText: z.string().optional(),
})

/**
 * The date the patent case action was recorded.
 */
export const zEventData = z
  .object({
    eventCode: z.string().optional(),
    eventDescriptionText: z.string().optional(),
    eventDate: z
      .string()
      .register(z.globalRegistry, {
        description: "The date the patent case action was recorded.",
      })
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "The date the patent case action was recorded.",
  })

export const zDocumentBag = z.object({
  documentBag: z
    .array(
      z.object({
        applicationNumberText: z.string().optional(),
        officialDate: z.string().optional(),
        documentIdentifier: z.string().optional(),
        documentCode: z.string().optional(),
        documentCodeDescriptionText: z.string().optional(),
        documentDirectionCategory: z.string().optional(),
        downloadOptionBag: z
          .array(
            z.object({
              mimeTypeIdentifier: z.string().optional(),
              downloadUrl: z.string().optional(),
              pageTotalQuantity: z.int().optional(),
            }),
          )
          .optional(),
      }),
    )
    .optional(),
})

/**
 * Contains pgpub zip and xml file meta data for an application
 */
export const zPgPubFileMetaData = z
  .object({
    zipFileName: z.string().optional(),
    productIdentifier: z.string().optional(),
    fileLocationURI: z.string().optional(),
    fileCreateDateTime: z.string().optional(),
    xmlFileName: z.string().optional(),
  })
  .register(z.globalRegistry, {
    description: "Contains pgpub zip and xml file meta data for an application",
  })

/**
 * Contains patent grant zip and xml file meta data for an application
 */
export const zGrantFileMetaData = z
  .object({
    zipFileName: z.string().optional(),
    productIdentifier: z.string().optional(),
    fileLocationURI: z.string().optional(),
    fileCreateDateTime: z.string().optional(),
    xmlFileName: z.string().optional(),
  })
  .register(z.globalRegistry, {
    description: "Contains patent grant zip and xml file meta data for an application",
  })

/**
 * This json structure represents all data fields possible for a patent application. Not all fields mentioned here will be returned in API response, only fields that have data should present in the response.
 */
export const zPatentDataResponse = z
  .object({
    count: z.int().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          applicationMetaData: zApplicationMetaData.optional(),
          correspondenceAddressBag: z
            .array(
              z.object({
                nameLineOneText: z.string().optional(),
                nameLineTwoText: z.string().optional(),
                addressLineOneText: z.string().optional(),
                addressLineTwoText: z.string().optional(),
                geographicRegionName: z.string().optional(),
                geographicRegionCode: z.string().optional(),
                postalCode: z.string().optional(),
                cityName: z.string().optional(),
                countryCode: z.string().optional(),
                countryName: z.string().optional(),
                postalAddressCategory: z.string().optional(),
              }),
            )
            .register(z.globalRegistry, {
              description: "Collection of correspondences",
            })
            .optional(),
          assignmentBag: z.array(zAssignment).optional(),
          recordAttorney: zRecordAttorney.optional(),
          foreignPriorityBag: z.array(zForeignPriority).optional(),
          parentContinuityBag: z.array(zParentContinuityData).optional(),
          childContinuityBag: z.array(zChildContinuityData).optional(),
          patentTermAdjustmentData: zPatentTermAdjustment.optional(),
          eventDataBag: z.array(zEventData).optional(),
          pgpubDocumentMetaData: zPgPubFileMetaData.optional(),
          grantDocumentMetaData: zGrantFileMetaData.optional(),
          lastIngestionDateTime: z.string().optional(),
        }),
      )
      .optional(),
    facets: z
      .array(
        z.object({
          applicationStatusCode: z
            .array(
              z.object({
                value: z.string().optional(),
                count: z.int().optional(),
              }),
            )
            .optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description:
      "This json structure represents all data fields possible for a patent application. Not all fields mentioned here will be returned in API response, only fields that have data should present in the response.",
  })

/**
 * This json structure represents data fields for status codes search API
 */
export const zStatusCodeSearchResponse = z
  .object({
    count: z.int().optional(),
    statusCodeBag: z
      .array(
        z.object({
          applicationStatusCode: z
            .int()
            .register(z.globalRegistry, {
              description: "Application status code",
            })
            .optional(),
          applicationStatusDescriptionText: z
            .string()
            .register(z.globalRegistry, {
              description: "Application status code description",
            })
            .optional(),
        }),
      )
      .optional(),
    requestIdentifier: z.string().optional(),
  })
  .register(z.globalRegistry, {
    description: "This json structure represents data fields for status codes search API",
  })

export const zBadRequestSchema = z.object({
  code: z.unknown().optional(),
  error: z.unknown().optional(),
  errorDetails: z.unknown().optional(),
  requestIdentifier: z.unknown().optional(),
})

export const zForbiddenSchema = z.object({
  code: z.string().optional(),
  error: z.string().optional(),
})

export const zNotFoundSchema = z.object({
  code: z.string().optional(),
  error: z.string().optional(),
  errorDetails: z.string().optional(),
  requestIdentifier: z.string().optional(),
})

export const zStatus413 = z.object({
  code: z.string().optional(),
  message: z.string().optional(),
  detailedMessage: z.string().optional(),
  requestIdentifier: z.string().optional(),
})

export const zInternalErrorSchema = z.object({
  code: z.string().optional(),
  error: z.string().optional(),
  errorDetails: z.string().optional(),
  requestIdentifier: z.string().optional(),
})

/**
 * Add filters to your search request by providing filter name and filter value where name in filter request some field in data set.
 */
export const zFilter = z
  .object({
    name: z.string().optional(),
    value: z.array(z.string()).optional(),
  })
  .register(z.globalRegistry, {
    description:
      "Add filters to your search request by providing filter name and filter value where name in filter request some field in data set.",
  })

/**
 * Range filter. Provide field from dataset and valueFrom and valueTo. If range filter is for date field, date must be in “yyyy-MM-dd” format
 */
export const zRange = z
  .object({
    field: z.string().optional(),
    valueFrom: z.string().optional(),
    valueTo: z.string().optional(),
  })
  .register(z.globalRegistry, {
    description:
      "Range filter. Provide field from dataset and valueFrom and valueTo. If range filter is for date field, date must be in “yyyy-MM-dd” format",
  })

/**
 * Sort you search result by providing field to be sorted and sort order
 */
export const zSort = z
  .object({
    field: z.string().optional(),
    order: z
      .enum(["Asc", "asc", "Desc", "desc"])
      .register(z.globalRegistry, {
        description: "Sort order. e.g. Asc, ASC, Desc, desc, DESC",
      })
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "Sort you search result by providing field to be sorted and sort order",
  })

/**
 * Pagination information.
 */
export const zPagination = z
  .object({
    offset: z
      .int()
      .gte(0)
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .register(z.globalRegistry, {
        description: "Start",
      })
      .optional()
      .default(0),
    limit: z
      .int()
      .gte(1)
      .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" })
      .register(z.globalRegistry, {
        description: "Maximum number of patent records to be returned in response",
      })
      .optional()
      .default(25),
  })
  .register(z.globalRegistry, {
    description: "Pagination information.",
  })

export const zPatentSearchRequest = z.object({
  q: z
    .string()
    .register(z.globalRegistry, {
      description: "Search by field value or pass opensearch string query syntax",
    })
    .optional(),
  filters: z.array(zFilter).optional(),
  rangeFilters: z.array(zRange).optional(),
  sort: z.array(zSort).optional(),
  fields: z.array(z.string()).optional(),
  pagination: zPagination.optional(),
  facets: z.array(z.string()).optional(),
})

export const zPatentDownloadRequest = z.object({
  q: z
    .string()
    .register(z.globalRegistry, {
      description: "Search by field value or pass opensearch string query syntax",
    })
    .optional(),
  filters: z.array(zFilter).optional(),
  rangeFilters: z.array(zRange).optional(),
  sort: z.array(zSort).optional(),
  fields: z.array(z.string()).optional(),
  pagination: zPagination.optional(),
  format: z
    .enum(["json", "csv"])
    .register(z.globalRegistry, {
      description: "Download format. csv or json",
    })
    .optional(),
})

export const zStatusCodeSearchRequest = z.object({
  q: z
    .string()
    .register(z.globalRegistry, {
      description: "Search by field value or pass opensearch string query syntax",
    })
    .optional(),
  pagination: zPagination.optional(),
})

/**
 * Facet Description
 */
export const zFacet = z
  .object({
    value: z.string().optional(),
    count: z.int().optional(),
  })
  .register(z.globalRegistry, {
    description: "Facet Description",
  })

/**
 * Object representing the error response
 */
export const zError = z
  .object({
    code: z.union([z.literal(400), z.literal(403), z.literal(404), z.literal(413), z.literal(500)]).optional(),
    description: z
      .enum(["Bad Request", "Unauthorized", "Not Found", "Payload Too Large", "Internal Server Error"])
      .optional(),
    detailedError: z.string().optional(),
    requestIdentifier: z.string().optional(),
  })
  .register(z.globalRegistry, {
    description: "Object representing the error response",
  })

export const zProductFileBag = z.object({
  count: z.int().optional(),
  fileDataBag: z
    .array(
      z.object({
        fileName: z.string().optional(),
        fileSize: z.number().optional(),
        fileDataFromDate: z.iso.date().optional(),
        fileDataToDate: z.iso.date().optional(),
        fileTypeText: z.string().optional(),
        fileDownloadURI: z.string().optional(),
        fileReleaseDate: z.string().optional(),
        fileDate: z.iso.date().optional(),
        fileLastModifiedDateTime: z.string().optional(),
      }),
    )
    .optional(),
})

export const zBulkDataProductBag = z.object({
  productIdentifier: z.string().optional(),
  productDescriptionText: z.string().optional(),
  productTitleText: z.string().optional(),
  productFrequencyText: z.string().optional(),
  daysOfWeekText: z.string().optional(),
  productLabelArrayText: z.array(z.string()).optional(),
  productDataSetArrayText: z.array(z.string()).optional(),
  productDataSetCategoryArrayText: z.array(z.string()).optional(),
  productFromDate: z.iso.date().optional(),
  productToDate: z.iso.date().optional(),
  productTotalFileSize: z.number().optional(),
  productFileTotalQuantity: z.number().optional(),
  lastModifiedDateTime: z.string().optional(),
  mimeTypeIdentifierArrayText: z.array(z.string()).optional(),
  productFileBag: zProductFileBag.optional(),
})

export const zBdssResponseProductBag = z.object({
  count: z.int().optional(),
  bulkDataProductBag: z.array(zBulkDataProductBag).optional(),
})

export const zFacets = z.object({
  productLabelArrayText: z
    .array(
      z.object({
        value: z.string().optional(),
        count: z.int().optional(),
      }),
    )
    .optional(),
  productDataSetArrayText: z
    .array(
      z.object({
        value: z.string().optional(),
        count: z.int().optional(),
      }),
    )
    .optional(),
  productCategoryArrayText: z
    .array(
      z.object({
        value: z.string().optional(),
        count: z.int().optional(),
      }),
    )
    .optional(),
  mimeTypeIdentifierArrayText: z
    .array(
      z.object({
        value: z.string().optional(),
        count: z.int().optional(),
      }),
    )
    .optional(),
  productFrequencyArrayText: z
    .array(
      z.object({
        value: z.string().optional(),
        count: z.int().optional(),
      }),
    )
    .optional(),
})

export const zBdssResponseBag = z.object({
  count: z.int().optional(),
  bulkDataProductBag: z.array(zBulkDataProductBag).optional(),
  facets: zFacets.optional(),
})

/**
 * Add filters to your search request by providing filter name and filter value where name in filter request some field in data set.
 */
export const zPetitionDecisionFilter = z
  .object({
    name: z.string().optional(),
    value: z.array(z.string()).optional(),
  })
  .register(z.globalRegistry, {
    description:
      "Add filters to your search request by providing filter name and filter value where name in filter request some field in data set.",
  })

/**
 * Range filter. Provide field from dataset and valueFrom and valueTo. If range filter is for date field, date must be in “yyyy-MM-dd” format
 */
export const zPetitionDecisionRange = z
  .object({
    field: z.string().optional(),
    valueFrom: z.string().optional(),
    valueTo: z.string().optional(),
  })
  .register(z.globalRegistry, {
    description:
      "Range filter. Provide field from dataset and valueFrom and valueTo. If range filter is for date field, date must be in “yyyy-MM-dd” format",
  })

/**
 * Sort you search result by providing field to be sorted and sort order
 */
export const zPetitionDecisionSort = z
  .object({
    field: z.string().optional(),
    order: z
      .enum(["Asc", "asc", "Desc", "desc"])
      .register(z.globalRegistry, {
        description: "Sort order. e.g. Asc, ASC, Desc, desc, DESC",
      })
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "Sort you search result by providing field to be sorted and sort order",
  })

export const zResponse400 = z.object({
  code: z.unknown().optional(),
  error: z.unknown().optional(),
  errorDetails: z.unknown().optional(),
  requestIdentifier: z.unknown().optional(),
})

export const zResponse403 = z.object({
  code: z.unknown().optional(),
  error: z.unknown().optional(),
})

export const zResponse404 = z.object({
  code: z.unknown().optional(),
  error: z.unknown().optional(),
  errorDetails: z.unknown().optional(),
  requestIdentifier: z.unknown().optional(),
})

export const zResponse500 = z.object({
  code: z.unknown().optional(),
  error: z.unknown().optional(),
  errorDetails: z.unknown().optional(),
  requestIdentifier: z.unknown().optional(),
})

export const zPetitionDecisionSearchRequest = z.object({
  q: z
    .string()
    .register(z.globalRegistry, {
      description: "Search by field value or pass opensearch string query syntax",
    })
    .optional(),
  filters: z.array(zPetitionDecisionFilter).optional(),
  rangeFilters: z.array(zPetitionDecisionRange).optional(),
  sort: z.array(zPetitionDecisionSort).optional(),
  fields: z.array(z.string()).optional(),
  pagination: zPagination.optional(),
  facets: z.array(z.string()).optional(),
})

export const zPetitionDecisionDownloadRequest = z.object({
  q: z
    .string()
    .register(z.globalRegistry, {
      description: "Search by field value or pass opensearch string query syntax",
    })
    .optional(),
  filters: z.array(zPetitionDecisionFilter).optional(),
  rangeFilters: z.array(zPetitionDecisionRange).optional(),
  sort: z.array(zPetitionDecisionSort).optional(),
  fields: z.array(z.string()).optional(),
  pagination: zPagination.optional(),
  format: z
    .enum(["json", "csv"])
    .register(z.globalRegistry, {
      description: "Download format. pdf,xml or docs",
    })
    .optional(),
})

export const zPetitionDecision = z.object({
  petitionDecisionRecordIdentifier: z.string().optional(),
  applicationNumberText: z.string().optional(),
  businessEntityStatusCategory: z.string().optional(),
  customerNumber: z.int().optional(),
  decisionDate: z.string().optional(),
  decisionPetitionTypeCode: z.int().optional(),
  decisionTypeCode: z.string().optional(),
  decisionPetitionTypeCodeDescriptionText: z.string().optional(),
  finalDecidingOfficeName: z.string().optional(),
  firstApplicantName: z.string().optional(),
  firstInventorToFileIndicator: z.boolean().optional(),
  groupArtUnitNumber: z.string().optional(),
  technologyCenter: z.string().optional(),
  inventionTitle: z.string().optional(),
  inventorBag: z.array(z.string()).optional(),
  actionTakenByCourtName: z.string().optional(),
  courtActionIndicator: z.boolean().optional(),
  lastIngestionDateTime: z.string().optional(),
  patentNumber: z.string().optional(),
  petitionIssueConsideredTextBag: z.array(z.string()).optional(),
  petitionMailDate: z.string().optional(),
  prosecutionStatusCodeDescriptionText: z.string().optional(),
  ruleBag: z.array(z.string()).optional(),
  statuteBag: z.array(z.string()).optional(),
})

export const zPetitionDecisionFacetEntity = z.object({
  value: z.string().optional(),
  count: z.int().optional(),
})

export const zPetitionDecisionFacet = z.object({
  technologyCenter: z.array(zPetitionDecisionFacetEntity).optional(),
  finalDecidingOfficeName: z.array(zPetitionDecisionFacetEntity).optional(),
  firstInventorToFileIndicator: z.array(zPetitionDecisionFacetEntity).optional(),
  decisionPetitionTypeCode: z.array(zPetitionDecisionFacetEntity).optional(),
  decisionTypeCodeDescriptionText: z.array(zPetitionDecisionFacetEntity).optional(),
  prosecutionStatusCodeDescriptionText: z.array(zPetitionDecisionFacetEntity).optional(),
  petitionIssueConsideredTextBag: z.array(zPetitionDecisionFacetEntity).optional(),
  statuteBag: z.array(zPetitionDecisionFacetEntity).optional(),
  ruleBag: z.array(zPetitionDecisionFacetEntity).optional(),
  actionTakenByCourtName: z.array(zPetitionDecisionFacetEntity).optional(),
  courtActionIndicator: z.array(zPetitionDecisionFacetEntity).optional(),
  businessEntityStatusCategory: z.array(zPetitionDecisionFacetEntity).optional(),
})

export const zPetitionDecisionResponseBag = z.object({
  count: z.int().optional(),
  petitionDecisionDataBag: z.array(zPetitionDecision).optional(),
  facets: z.array(zPetitionDecisionFacet).optional(),
})

export const zPetitionDecisionDocument = z.object({
  applicationNumberText: z.string().optional(),
  officialDate: z.string().optional(),
  documentIdentifier: z.string().optional(),
  documentCode: z.string().optional(),
  documentCodeDescriptionText: z.string().optional(),
  documentDirectionCategory: z.string().optional(),
  downloadOptionBag: z
    .array(
      z.object({
        mimeTypeIdentifier: z.string().optional(),
        documentURI: z.string().optional(),
        pageTotalQuantity: z.int().optional(),
      }),
    )
    .optional(),
})

export const zPetitionDecisionAndDocuments = zPetitionDecision.and(
  z.object({
    documentBag: z.array(zPetitionDecisionDocument).optional(),
  }),
)

export const zPetitionDecisionIdentifierResponseBag = z.object({
  count: z.int().optional(),
  petitionDecisionDataBag: z.array(zPetitionDecisionAndDocuments).optional(),
})

/**
 * Boolean/wildcard search query string.
 */
export const zParamQ = z.string().register(z.globalRegistry, {
  description: "Boolean/wildcard search query string.",
})

export const zQ = zParamQ

/**
 * Field followed by sort order, e.g. 'fieldName desc'.
 */
export const zParamSort = z.string().register(z.globalRegistry, {
  description: "Field followed by sort order, e.g. 'fieldName desc'.",
})

export const zSort2 = zParamSort

export const zParamOffset = z.int().gte(0).default(0)

export const zOffset = zParamOffset

export const zParamLimit = z.int().gte(1).default(25)

export const zLimit = zParamLimit

/**
 * Comma-separated facet fields.
 */
export const zParamFacets = z.string().register(z.globalRegistry, {
  description: "Comma-separated facet fields.",
})

export const zFacets2 = zParamFacets

/**
 * Comma-separated field list to include in the response.
 */
export const zParamFields = z.string().register(z.globalRegistry, {
  description: "Comma-separated field list to include in the response.",
})

export const zFields = zParamFields

/**
 * Whitespace-separated filters.
 */
export const zParamFilters = z.string().register(z.globalRegistry, {
  description: "Whitespace-separated filters.",
})

export const zFilters = zParamFilters

/**
 * Range filter: 'field YYYY-MM-DD:YYYY-MM-DD'.
 */
export const zParamRangeFilters = z.string().register(z.globalRegistry, {
  description: "Range filter: 'field YYYY-MM-DD:YYYY-MM-DD'.",
})

export const zRangeFilters = zParamRangeFilters

export const zParamFormat = z.enum(["json", "csv"])

export const zFormat = zParamFormat

export const zPatentAppealDataBag = z.object({
  appealNumber: z.string().optional(),
  lastModifiedDateTime: z.string().optional(),
  appealDocumentCategory: z.string().optional(),
  appealMetaData: z
    .object({
      docketNoticeMailedDate: z.iso.date().optional(),
      appealFilingDate: z.iso.date().optional(),
      appealLastModifiedDate: z.iso.date().optional(),
      appealLastModifiedDateTime: z.string().optional(),
      applicationTypeCategory: z.string().optional(),
      fileDownloadURI: z.string().optional(),
    })
    .optional(),
  appelantData: z
    .object({
      applicationNumberText: z.string().optional(),
      counselName: z.string().optional(),
      groupArtUnitNumber: z.string().optional(),
      inventorName: z.string().optional(),
      realPartyName: z.string().optional(),
      patentNumber: z.string().optional(),
      patentOwnerName: z.string().optional(),
      publicationDate: z.string().optional(),
      publicationNumber: z.string().optional(),
      techCenterNumber: z.string().optional(),
    })
    .optional(),
  requestorData: z
    .object({
      thirdPartyName: z.string().optional(),
    })
    .optional(),
  documentData: z
    .object({
      documentFilingDate: z.string().optional(),
      documentIdentifier: z.string().optional(),
      documentName: z.string().optional(),
      documentSizeQuantity: z.int().optional(),
      documentOCRText: z.string().optional(),
      documentTypeCategory: z.string().optional(),
      downloadURI: z.string().optional(),
    })
    .optional(),
})

export const zAppealDecisionDataResponse = z.object({
  count: z.int().optional(),
  patentAppealDataBag: z.array(zPatentAppealDataBag).optional(),
})

export const zPatentAppealDataBag2 = zPatentAppealDataBag

export const zSearchRequest = zPatentSearchRequest

export const zDownloadRequest = zPatentDownloadRequest

export const zLookupRequest = z.object({
  trialNumber: z.string(),
})

export const zTrialMetaData = z.object({
  accordedFilingDate: z.iso.date().optional(),
  institutionDecisionDate: z.iso.date().optional(),
  latestDecisionDate: z.iso.date().optional(),
  petitionFilingDate: z.iso.date().optional(),
  terminationDate: z.iso.date().optional(),
  trialLastModifiedDateTime: z.string().optional(),
  trialLastModifiedDate: z.iso.date().optional(),
  trialStatusCategory: z.string().optional(),
  trialTypeCode: z.string().optional(),
})

export const zPatentOwnerData = z.object({
  applicationNumberText: z.string().optional(),
  counselName: z.string().optional(),
  grantDate: z.iso.date().optional(),
  groupArtUnitNumber: z.string().optional(),
  inventorName: z.string().optional(),
  realPartyInInterestName: z.string().optional(),
  patentNumber: z.string().optional(),
  patentOwnerName: z.string().optional(),
  technologyCenterNumber: z.string().optional(),
})

export const zRegularPetitionerData = z.object({
  counselName: z.string().optional(),
  realPartyInInterestName: z.string().optional(),
})

export const zRespondentData = z.object({
  applicationNumberText: z.string().optional(),
  counselName: z.string().optional(),
  grantDate: z.iso.date().optional(),
  groupArtUnitNumber: z.string().optional(),
  inventorName: z.string().optional(),
  realPartyInInterestName: z.string().optional(),
  patentNumber: z.string().optional(),
  patentOwnerName: z.string().optional(),
  technologyCenterNumber: z.string().optional(),
})

export const zDerivationPetitionerData = z.object({
  applicationNumberText: z.string().optional(),
  counselName: z.string().optional(),
  grantDate: z.iso.date().optional(),
  groupArtUnitNumber: z.string().optional(),
  inventorName: z.string().optional(),
  realPartyInInterestName: z.string().optional(),
  patentNumber: z.string().optional(),
  technologyCenterNumber: z.string().optional(),
  patentOwnerName: z.string().optional(),
})

/**
 * A single PTAB trial proceeding record.
 */
export const zPatentTrialProceedingDataBag = z
  .object({
    trialNumber: z.string().optional(),
    lastModifiedDateTime: z.string().optional(),
    trialMetaData: zTrialMetaData.optional(),
    patentOwnerData: zPatentOwnerData.optional(),
    regularPetitionerData: zRegularPetitionerData.optional(),
    respondentData: zRespondentData.optional(),
    derivationPetitionerData: zDerivationPetitionerData.optional(),
  })
  .register(z.globalRegistry, {
    description: "A single PTAB trial proceeding record.",
  })

export const zProceedingDataResponse = z.object({
  count: z.int().optional(),
  requestIdentifier: z.string().optional(),
  patentTrialProceedingDataBag: z.array(zPatentTrialProceedingDataBag).optional(),
})

export const zPatentTrialProceedingDataBag2 = zPatentTrialProceedingDataBag

export const zDocumentData = z.object({
  documentCategory: z.string().optional(),
  documentFilingDate: z.iso.date().optional(),
  documentIdentifier: z.string().optional(),
  documentName: z.string().optional(),
  documentNumber: z.int().optional(),
  documentSizeQuantity: z.int().optional(),
  documentOCRText: z.string().optional(),
  documentTitleText: z.string().optional(),
  documentTypeDescriptionText: z.string().optional(),
  downloadURI: z.url().optional(),
  filingPartyCategory: z.string().optional(),
  mimeTypeIdentifier: z.string().optional(),
  documentStatus: z.string().optional(),
})

export const zDecisionData = z.object({
  statuteAndRuleBag: z.array(z.string()).optional(),
  decisionIssueDate: z.iso.date().optional(),
  decisionTypeCategory: z.string().optional(),
  issueTypeBag: z.array(z.string()).optional(),
  trialOutcomeCategory: z.string().optional(),
})

export const zFacetItem = z.object({
  name: z.string().optional(),
  quantity: z.int().optional(),
})

export const zInterferencePartyData = z.object({
  applicationNumberText: z.string().optional(),
  counselName: z.string().optional(),
  grantDate: z.iso.date().optional(),
  groupArtUnitNumber: z.string().optional(),
  inventorName: z.string().optional(),
  realPartyInInterestName: z.string().optional(),
  patentNumber: z.string().optional(),
  patentOwnerName: z.string().optional(),
  technologyCenterNumber: z.string().optional(),
  publicationDate: z.iso.date().optional(),
  publicationNumber: z.string().optional(),
})

export const zInterferenceDecisionDocumentData = z.object({
  documentFilingDate: z.iso.date().optional(),
  documentIdentifier: z.string().optional(),
  documentName: z.string().optional(),
  documentSizeQuantity: z.coerce
    .bigint()
    .min(BigInt("-9223372036854775808"), { error: "Invalid value: Expected int64 to be >= -9223372036854775808" })
    .max(BigInt("9223372036854775807"), { error: "Invalid value: Expected int64 to be <= 9223372036854775807" })
    .optional(),
  documentOCRText: z.string().optional(),
  documentTitleText: z.string().optional(),
  downloadURI: z.string().optional(),
  statuteAndRuleBag: z.array(z.string()).optional(),
  decisionIssueDate: z.iso.date().optional(),
  decisionTypeCategory: z.string().optional(),
  issueTypeBag: z.array(z.string()).optional(),
  interferenceOutcomeCategory: z.string().optional(),
})

export const zInterferenceDecisionRecord = z.object({
  interferenceNumber: z.string(),
  lastModifiedDateTime: z.string().optional(),
  interferenceMetaData: z
    .object({
      interferenceStyleName: z.string().optional(),
      interferenceLastModifiedDate: z.iso.date().optional(),
      fileDownloadURI: z.string().optional(),
    })
    .optional(),
  seniorPartyData: zInterferencePartyData.optional(),
  juniorPartyData: zInterferencePartyData.optional(),
  additionalPartyDataBag: z
    .array(
      z.object({
        applicationNumberText: z.string().optional(),
        inventorName: z.string().optional(),
        additionalPartyName: z.string().optional(),
        patentNumber: z.string().optional(),
      }),
    )
    .optional(),
  documentData: zInterferenceDecisionDocumentData.optional(),
})

export const zInterferenceDecisionDataResponse = z.object({
  count: z
    .int()
    .min(-2147483648, { error: "Invalid value: Expected int32 to be >= -2147483648" })
    .max(2147483647, { error: "Invalid value: Expected int32 to be <= 2147483647" }),
  requestIdentifier: z.string(),
  patentInterferenceDataBag: z.array(zInterferenceDecisionRecord),
})

/**
 * A single PTAB document record.
 */
export const zPatentTrialDocumentDataBag = z
  .object({
    trialDocumentCategory: z.string().optional(),
    lastModifiedDateTime: z.string().optional(),
    trialNumber: z.string().optional(),
    trialTypeCode: z.string().optional(),
    trialMetaData: zTrialMetaData.optional(),
    patentOwnerData: zPatentOwnerData.optional(),
    regularPetitionerData: zRegularPetitionerData.optional(),
    respondentData: zRespondentData.optional(),
    derivationPetitionerData: zDerivationPetitionerData.optional(),
    documentData: zDocumentData.optional(),
    decisionData: zDecisionData.optional(),
  })
  .register(z.globalRegistry, {
    description: "A single PTAB document record.",
  })

export const zDocumentDataResponse = z.object({
  count: z.int().optional(),
  patentTrialDocumentDataBag: z.array(zPatentTrialDocumentDataBag).optional(),
  facets: z.array(zFacet).optional(),
})

export const zPatentTrialDocumentDataBag2 = zPatentTrialDocumentDataBag

/**
 * Identical structure, just decisions-only data.
 */
export const zDecisionDataResponse = zDocumentDataResponse

/**
 * Decision records only (trialDocumentCategory = decision).
 */
export const zPatentTrialDecisionDataBag = zPatentTrialDocumentDataBag

export const zPatentTrialDecisionDataBag2 = zPatentTrialDecisionDataBag

export const zGetApiV1PatentApplicationsSearchData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsSearchResponse = zPatentDataResponse

export const zPostApiV1PatentApplicationsSearchData = z.object({
  body: zPatentSearchRequest.optional(),
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentApplicationsSearchResponse = zPatentDataResponse

export const zGetApiV1PatentApplicationsSearchDownloadData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Page number to begin with",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
      format: z
        .string()
        .register(z.globalRegistry, {
          description: "Download Format",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsSearchDownloadResponse = zPatentDataResponse

export const zPostApiV1PatentApplicationsSearchDownloadData = z.object({
  body: zPatentDownloadRequest.optional(),
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentApplicationsSearchDownloadResponse = zPatentDataResponse

export const zGetApiV1PatentApplicationsByApplicationNumberTextData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description:
        "Patent application number. <b>Note</b>:Application number having special character e.g PCT/BR00/000001 must be encoded with UTF-8 character encoding standard",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextResponse = zPatentDataResponse

export const zGetApiV1PatentApplicationsByApplicationNumberTextMetaDataData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "Patent application number",
    }),
  }),
  query: z.never().optional(),
})

/**
 * Application meta data section
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextMetaDataResponse = z
  .object({
    count: z.unknown().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          applicationMetaData: zApplicationMetaData.optional(),
        }),
      )
      .optional(),
    requestIdentifier: z.unknown().optional(),
  })
  .register(z.globalRegistry, {
    description: "Application meta data section",
  })

export const zGetApiV1PatentApplicationsByApplicationNumberTextAdjustmentData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "Patent application number",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextAdjustmentResponse = z
  .object({
    count: z.int().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          patentTermAdjustmentData: zPatentTermAdjustment.optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "OK",
  })

export const zGetApiV1PatentApplicationsByApplicationNumberTextAssignmentData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "Patent application number",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextAssignmentResponse = z
  .object({
    count: z.int().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          assignmentBag: z.array(zAssignment).optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "OK",
  })

export const zGetApiV1PatentApplicationsByApplicationNumberTextAttorneyData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "Patent application number",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextAttorneyResponse = z
  .object({
    count: z.int().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          recordAttorney: zRecordAttorney.optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "OK",
  })

export const zGetApiV1PatentApplicationsByApplicationNumberTextContinuityData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "Patent application number",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextContinuityResponse = z
  .object({
    count: z.int().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          parentContinuityBag: z.array(zParentContinuityData).optional(),
          childContinuityBag: z.array(zChildContinuityData).optional(),
          requestIdentifier: z.string().optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "OK",
  })

export const zGetApiV1PatentApplicationsByApplicationNumberTextForeignPriorityData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "Patent application number",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextForeignPriorityResponse = z
  .object({
    count: z.int().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          foreignPriorityBag: z.array(zForeignPriority).optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "OK",
  })

export const zGetApiV1PatentApplicationsByApplicationNumberTextTransactionsData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "Patent application number",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextTransactionsResponse = z
  .object({
    count: z.int().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          eventDataBag: z.array(zEventData).optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "OK",
  })

export const zGetApiV1PatentApplicationsByApplicationNumberTextDocumentsData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "application number",
    }),
  }),
  query: z
    .object({
      documentCodes: z
        .string()
        .register(z.globalRegistry, {
          description: "single or multiple comma separated document codes",
        })
        .optional(),
      officialDateFrom: z
        .string()
        .register(z.globalRegistry, {
          description: "Search by document official date from",
        })
        .optional(),
      officialDateTo: z
        .string()
        .register(z.globalRegistry, {
          description: "Search by document official date to",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextDocumentsResponse = zDocumentBag

export const zGetApiV1PatentApplicationsByApplicationNumberTextAssociatedDocumentsData = z.object({
  body: z.never().optional(),
  path: z.object({
    applicationNumberText: z.string().register(z.globalRegistry, {
      description: "application number",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentApplicationsByApplicationNumberTextAssociatedDocumentsResponse = z
  .object({
    count: z.int().optional(),
    patentFileWrapperDataBag: z
      .array(
        z.object({
          applicationNumberText: z
            .string()
            .register(z.globalRegistry, {
              description: "Free format of application number",
            })
            .optional(),
          pgpubDocumentMetaData: zPgPubFileMetaData.optional(),
          grantDocumentMetaData: zGrantFileMetaData.optional(),
          requestIdentifier: z.string().optional(),
        }),
      )
      .optional(),
  })
  .register(z.globalRegistry, {
    description: "OK",
  })

export const zGetApiV1PatentStatusCodesData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentStatusCodesResponse = zStatusCodeSearchResponse

export const zPostApiV1PatentStatusCodesData = z.object({
  body: zStatusCodeSearchRequest.optional(),
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentStatusCodesResponse = zStatusCodeSearchResponse

export const zGetApiV1DatasetsProductsSearchData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1DatasetsProductsSearchResponse = zBdssResponseBag

export const zGetApiV1DatasetsProductsByProductIdentifierData = z.object({
  body: z.never().optional(),
  path: z.object({
    productIdentifier: z.string().register(z.globalRegistry, {
      description: "productIdentifier represents product Short name",
    }),
  }),
  query: z
    .object({
      fileDataFromDate: z
        .string()
        .register(z.globalRegistry, {
          description: "fileDataFromDate",
        })
        .optional(),
      fileDataToDate: z
        .string()
        .register(z.globalRegistry, {
          description: "fileDataToDate",
        })
        .optional(),
      offset: z
        .int()
        .register(z.globalRegistry, {
          description: "Number of product file records to skip",
        })
        .optional(),
      limit: z
        .int()
        .register(z.globalRegistry, {
          description: "Number of product file records to collect",
        })
        .optional(),
      includeFiles: z
        .string()
        .register(z.globalRegistry, {
          description:
            "value true if product files should be included or false if they should be omitted from the response",
        })
        .optional(),
      latest: z
        .string()
        .register(z.globalRegistry, {
          description: "value is true if only the latest product file should be returned for this specific product",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1DatasetsProductsByProductIdentifierResponse = zBdssResponseProductBag

export const zGetApiV1DatasetsProductsFilesByProductIdentifierByFileNameData = z.object({
  body: z.never().optional(),
  path: z.object({
    productIdentifier: z.string(),
    fileName: z.string(),
  }),
  query: z.never().optional(),
})

export const zGetApiV1PetitionDecisionsSearchData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PetitionDecisionsSearchResponse = zPetitionDecisionResponseBag

export const zPostApiV1PetitionDecisionsSearchData = z.object({
  body: zPetitionDecisionSearchRequest.optional(),
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PetitionDecisionsSearchResponse = zPetitionDecisionResponseBag

export const zGetApiV1PetitionDecisionsSearchDownloadData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
      format: z
        .string()
        .register(z.globalRegistry, {
          description: "Download Format",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PetitionDecisionsSearchDownloadResponse = zPetitionDecisionResponseBag

export const zPostApiV1PetitionDecisionsSearchDownloadData = z.object({
  body: zPetitionDecisionDownloadRequest.optional(),
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PetitionDecisionsSearchDownloadResponse = zPetitionDecisionResponseBag

export const zGetApiV1PetitionDecisionsByPetitionDecisionRecordIdentifierData = z.object({
  body: z.never().optional(),
  path: z.object({
    petitionDecisionRecordIdentifier: z.string().register(z.globalRegistry, {
      description: "Petition Decision number",
    }),
  }),
  query: z
    .object({
      includeDocuments: z
        .boolean()
        .register(z.globalRegistry, {
          description:
            "This is a true or false...yes to include petition decision documents in the response and no to omit the petition decision documents from the response",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PetitionDecisionsByPetitionDecisionRecordIdentifierResponse =
  zPetitionDecisionIdentifierResponseBag

export const zGetApiV1PatentTrialsProceedingsSearchData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsProceedingsSearchResponse = zProceedingDataResponse

export const zPostApiV1PatentTrialsProceedingsSearchData = z.object({
  body: zSearchRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentTrialsProceedingsSearchResponse = zProceedingDataResponse

export const zGetApiV1PatentTrialsProceedingsSearchDownloadData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
      format: z
        .string()
        .register(z.globalRegistry, {
          description: "Download Format",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsProceedingsSearchDownloadResponse = zProceedingDataResponse

export const zPostApiV1PatentTrialsProceedingsSearchDownloadData = z.object({
  body: zDownloadRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentTrialsProceedingsSearchDownloadResponse = zProceedingDataResponse

export const zGetApiV1PatentTrialsProceedingsByTrialNumberData = z.object({
  body: z.never().optional(),
  path: z.object({
    trialNumber: z.string().register(z.globalRegistry, {
      description: "trialNumber number.",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsProceedingsByTrialNumberResponse = zProceedingDataResponse

export const zGetApiV1PatentTrialsDecisionsSearchData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsDecisionsSearchResponse = zDecisionDataResponse

export const zPostApiV1PatentTrialsDecisionsSearchData = z.object({
  body: zPatentSearchRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentTrialsDecisionsSearchResponse = zDecisionDataResponse

export const zGetApiV1PatentTrialsDecisionsSearchDownloadData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
      format: z
        .string()
        .register(z.globalRegistry, {
          description: "Download Format",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsDecisionsSearchDownloadResponse = zDecisionDataResponse

export const zPostApiV1PatentTrialsDecisionsSearchDownloadData = z.object({
  body: zDownloadRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentTrialsDecisionsSearchDownloadResponse = zDecisionDataResponse

export const zGetApiV1PatentTrialsDecisionsByDocumentIdentifierData = z.object({
  body: z.never().optional(),
  path: z.object({
    documentIdentifier: z.string(),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsDecisionsByDocumentIdentifierResponse = zDecisionDataResponse

export const zGetApiV1PatentTrialsByTrialNumberDecisionsData = z.object({
  body: z.never().optional(),
  path: z.object({
    trialNumber: z.string(),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsByTrialNumberDecisionsResponse = zDecisionDataResponse

export const zGetApiV1PatentTrialsDocumentsSearchData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsDocumentsSearchResponse = zDocumentDataResponse

export const zPostApiV1PatentTrialsDocumentsSearchData = z.object({
  body: zSearchRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentTrialsDocumentsSearchResponse = zDocumentDataResponse

export const zGetApiV1PatentTrialsDocumentsSearchDownloadData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
      format: z
        .string()
        .register(z.globalRegistry, {
          description: "Download Format",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsDocumentsSearchDownloadResponse = zDocumentDataResponse

export const zPostApiV1PatentTrialsDocumentsSearchDownloadData = z.object({
  body: zDownloadRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentTrialsDocumentsSearchDownloadResponse = zDocumentDataResponse

export const zGetApiV1PatentTrialsDocumentsByDocumentIdentifierData = z.object({
  body: z.never().optional(),
  path: z.object({
    documentIdentifier: z.string().register(z.globalRegistry, {
      description: "document Identifier.",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsDocumentsByDocumentIdentifierResponse = zDocumentDataResponse

export const zGetApiV1PatentTrialsByTrialNumberDocumentsData = z.object({
  body: z.never().optional(),
  path: z.object({
    trialNumber: z.string().register(z.globalRegistry, {
      description: "trialNumber number.",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentTrialsByTrialNumberDocumentsResponse = zDocumentDataResponse

export const zGetApiV1PatentAppealsDecisionsSearchData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
    })
    .optional(),
})

/**
 * Successful search
 */
export const zGetApiV1PatentAppealsDecisionsSearchResponse = zAppealDecisionDataResponse

export const zPostApiV1PatentAppealsDecisionsSearchData = z.object({
  body: zPatentSearchRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * Successful search
 */
export const zPostApiV1PatentAppealsDecisionsSearchResponse = zAppealDecisionDataResponse

export const zGetApiV1PatentAppealsDecisionsSearchDownloadData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
      format: z
        .string()
        .register(z.globalRegistry, {
          description: "Download Format",
        })
        .optional(),
    })
    .optional(),
})

/**
 * Successful search
 */
export const zGetApiV1PatentAppealsDecisionsSearchDownloadResponse = zAppealDecisionDataResponse

export const zPostApiV1PatentAppealsDecisionsSearchDownloadData = z.object({
  body: zDownloadRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * Successful search
 */
export const zPostApiV1PatentAppealsDecisionsSearchDownloadResponse = zAppealDecisionDataResponse

export const zGetApiV1PatentAppealsDecisionsByDocumentIdentifierData = z.object({
  body: z.never().optional(),
  path: z.object({
    documentIdentifier: z.string().register(z.globalRegistry, {
      description: "document Identifier.",
    }),
  }),
  query: z.never().optional(),
})

/**
 * Appeal decision found
 */
export const zGetApiV1PatentAppealsDecisionsByDocumentIdentifierResponse = zAppealDecisionDataResponse

export const zGetApiV1PatentAppealsByAppealNumberDecisionsData = z.object({
  body: z.never().optional(),
  path: z.object({
    appealNumber: z.string(),
  }),
  query: z.never().optional(),
})

/**
 * Appeal decision found
 */
export const zGetApiV1PatentAppealsByAppealNumberDecisionsResponse = zAppealDecisionDataResponse

export const zGetApiV1PatentInterferencesDecisionsSearchData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentInterferencesDecisionsSearchResponse = zInterferenceDecisionDataResponse

export const zPostApiV1PatentInterferencesDecisionsSearchData = z.object({
  body: zPatentSearchRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zPostApiV1PatentInterferencesDecisionsSearchResponse = zInterferenceDecisionDataResponse

export const zGetApiV1PatentInterferencesDecisionsSearchDownloadData = z.object({
  body: z.never().optional(),
  path: z.never().optional(),
  query: z
    .object({
      q: z
        .string()
        .register(z.globalRegistry, {
          description:
            'A search query string which accepts boolean operators (AND, OR, NOT), wildcards (*), and exact phrases ("").',
        })
        .optional(),
      sort: z
        .string()
        .register(z.globalRegistry, {
          description: "Field to be sorted followed by sort order",
        })
        .optional(),
      offset: z
        .int()
        .gte(0)
        .register(z.globalRegistry, {
          description: "Position in the dataset of a particular record",
        })
        .optional(),
      limit: z
        .int()
        .gte(1)
        .register(z.globalRegistry, {
          description: "Limit the number of results returned",
        })
        .optional(),
      facets: z
        .string()
        .register(z.globalRegistry, {
          description: "List of fields names to be faceted upon separated by comma (<b>,</b>)",
        })
        .optional(),
      fields: z
        .string()
        .register(z.globalRegistry, {
          description: "Limits the response by specifying which fields from dataset should be included.",
        })
        .optional(),
      filters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter data by supplying filter parameter. Provide field name and its value.",
        })
        .optional(),
      rangeFilters: z
        .string()
        .register(z.globalRegistry, {
          description: "Filter the data by supplying range of values. Applicable for number and date type fields.",
        })
        .optional(),
      format: z
        .string()
        .register(z.globalRegistry, {
          description: "Download Format",
        })
        .optional(),
    })
    .optional(),
})

/**
 * OK (file or JSON depending on format)
 */
export const zGetApiV1PatentInterferencesDecisionsSearchDownloadResponse = zInterferenceDecisionDataResponse

export const zPostApiV1PatentInterferencesDecisionsSearchDownloadData = z.object({
  body: zPatentDownloadRequest,
  path: z.never().optional(),
  query: z.never().optional(),
})

/**
 * OK (file or JSON depending on format)
 */
export const zPostApiV1PatentInterferencesDecisionsSearchDownloadResponse = zInterferenceDecisionDataResponse

export const zGetApiV1PatentInterferencesByInterferenceNumberDecisionsData = z.object({
  body: z.never().optional(),
  path: z.object({
    interferenceNumber: z.string().register(z.globalRegistry, {
      description: "Interference number (e.g., 103751).",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentInterferencesByInterferenceNumberDecisionsResponse = zInterferenceDecisionDataResponse

export const zGetApiV1PatentInterferencesDecisionsByDocumentIdentifierData = z.object({
  body: z.never().optional(),
  path: z.object({
    documentIdentifier: z.string().register(z.globalRegistry, {
      description: "Unique document identifier (opaque string).",
    }),
  }),
  query: z.never().optional(),
})

/**
 * OK
 */
export const zGetApiV1PatentInterferencesDecisionsByDocumentIdentifierResponse = zInterferenceDecisionDataResponse
